import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "../views/Errors/NotFound.vue";
import Internal from "../views/Errors/Internal.vue";
import LaraRedirection from "../views/LaraRedirection.vue";
import TerminerPlusTard from "../views/TerminerPlusTard.vue";
import Facture from "../views/Facture.vue";
import LaraConnexionExterne from "../views/LaraConnexionExterne.vue";
import DemandeAdmissionPublic from "../views/DemandeAdmissionPublic.vue";
import Merci from "../views/Merci.vue";
import PocInfoBulle from "../views/PocParamInfoBulle.vue";
import DemandeDejaValidee from "../views/DemandeInscription/DemandeDejaValidee";
import DemandeInscriptionEnregistree from "../views/DemandeInscription/DemandeInscriptionEnregistree";
import DemandeRenouvellementEnregistree from "../views/DemandeInscriptionRenouvellement/DemandeRenouvellementEnregistree";
import RedirectionFacture from "../views/DemandeInscription/RedirectionFacture";
import RetraitVolontaire from "../views/DemandeInscription/RetraitVolontaire";
import FormulaireDemission from "../views/DemandeInscription/FormulaireDemission";
import SacRequest from "../views/SacRequest";
import UIEI from "../views/UIEI";

import RoutesDemandeAdmissionInitiale from "./demandeAdmissionInitiale";
import RoutesAdmissionPA from "./AdmissionPA";
import RoutesDemandeAdmissionPRP from "./demandeAdmissionPRP";
import RoutesDemandeAdmissionComplementaire from "./demandeAdmissionComplementaire";
import RoutesDemandeReadmission from "./demandeAdmissionReAdmission";
import RoutesDemandeInscriptionInitiale from "./demandeInscriptionInitiale";
import RoutesDemandeInscriptionRenouvellement from "./demandeInscriptionRenouvellement";
import RoutesUnitaire from "./unitaire";

Vue.use(VueRouter);

// Prévoir une redirection vers une page par défaut pour l'url index.html
const routes = [
  ...RoutesDemandeAdmissionInitiale,
  ...RoutesAdmissionPA,
  ...RoutesDemandeAdmissionPRP,
  ...RoutesDemandeAdmissionComplementaire,
  ...RoutesDemandeReadmission,
  ...RoutesDemandeInscriptionInitiale,
  ...RoutesDemandeInscriptionRenouvellement,
  ...RoutesUnitaire,
  {
    path: "/404",
    name: "NotFound",
    component: NotFound,
    props: true,
    meta: {
      title: "Ressource absente | OTSTCFQ",
    },
  },
  {
    path: "/500",
    name: "InternalError",
    component: Internal,
    props: true,
    meta: {
      title: "Erreur interne | OTSTCFQ",
    },
  },
  {
    path: "/merci",
    name: "Merci",
    component: Merci,
    meta: {
      title: "Merci ! | OTSTCFQ",
    },
  },
  {
    path: "/lara-redirection/:contactId",
    name: "LaraRedirection",
    component: LaraRedirection,
  },
  {
    path: "/terminer-plus-tard",
    name: "TerminerPlusTard",
    component: TerminerPlusTard,
  },
  {
    path: "/facture/:idFacture",
    name: "/facture",
    component: Facture,
    meta: {
      title: "Facture | OTSTCFQ",
    },
  },
  {
    path: "/lara-connexion-externe",
    name: "/LaraConnexionExterne",
    component: LaraConnexionExterne,
    meta: {
      title: "Lara Connexion Externe | OTSTCFQ",
    },
  },
  {
    path: "/demande-admission-public",
    name: "/DemandeAdmissionPublic",
    component: DemandeAdmissionPublic,
    meta: {
      title: "Demande admission publique | OTSTCFQ",
    },
  },
  {
    path: "/demande-inscription/deja-validee",
    name: "DemandeInscription/DemandeDejaValidee",
    component: DemandeDejaValidee,
  },
  {
    path: "/demande-inscription/confirmation-inscription",
    name: "DemandeInscription/DemandeInscriptionEnregistree",
    component: DemandeInscriptionEnregistree,
    props: true,
  },
  {
    path: "/demande-inscription/confirmation-inscription-renouvellement",
    name: "DemandeInscriptionRenouvellement/DemandeRenouvellementEnregistree",
    component: DemandeRenouvellementEnregistree,
    props: true,
  },
  {
    path: "/demande-inscription/retrait-volontaire",
    name: "DemandeInscription/RetraitVolontaire",
    component: RetraitVolontaire,
  },
  {
    path: "/demande-inscription/demission",
    name: "DemandeInscription/Demission",
    component: FormulaireDemission,
    meta: {
      title: "Formulaire de démission | OTSTCFQ",
    },
  },
  {
    path: "/demande-inscription/redirection-facture",
    name: "DemandeInscription/RedirectionFacture",
    component: RedirectionFacture,
  },
  {
    path: "/pocParamInfoBulle",
    name: "PocParamInfoBulle",
    component: PocInfoBulle,
  },
  {
    path: "/sac-request/:contactId?",
    name: "SacRequest",
    component: SacRequest,
    meta: {
      title: "Demande au service à la clientèle | OTSTCFQ",
    },
  },
  {
    path: "/UIEI",
    name: "UIEI",
    component: UIEI,
    meta: {
      title: "UIEI | OTSTCFQ",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

function redirectHashToHistory(to) {
  if (to.hash.indexOf("#") === -1) {
    return;
  }

  router.push(to.hash.replace("#", ""));
}
router.beforeResolve((to, from, next) => {
  redirectHashToHistory(to);
  next();
});

export default router;